module.exports = __webpack_public_path__ + "img/DSC_0083.48abf5cc.jpg";